// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"32365817","1706":"d4f6acb1","4052":"4c35518c","6248":"4c9fcea8","7219":"8c7c6a3c","9371":"41cfad47"}[chunkId] + ".chunk.css";
};